import { withBemMod } from '@bem-react/core';

import { cnTextarea } from '../../Textarea.cn';

import './Textarea_view_contrast.css';

export type WithViewContrastProps = {
    view?: 'contrast';
};

export const withViewContrast = withBemMod<WithViewContrastProps>(cnTextarea(), {});
